import React from 'react';
import Icon from './Icon';
import Tooltip from './Tooltip';
import EventBus from '../../utils/EventBus';
import styles from './ExportUsersButton.module.css';

// Small download icon placed next to a count — onExport() does the actual
// fetch/download (e.g. campaignService.exportUsers). Kept generic so
// journey/segment counts can reuse it with their own export call.
class ExportUsersButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = { busy: false };
    this.handleClick = this.handleClick.bind(this);
  }

  async handleClick(e) {
    e.stopPropagation();
    if (this.state.busy) return;
    this.setState({ busy: true });
    try {
      await this.props.onExport();
    } catch (err) {
      EventBus.emit('toast', { type: 'error', message: err.message || 'Export failed.' });
    } finally {
      this.setState({ busy: false });
    }
  }

  render() {
    const { label = 'Export unique users (CSV)', disabled } = this.props;
    const { busy } = this.state;
    return (
      <Tooltip content={busy ? 'Preparing export…' : label}>
        <button
          type="button"
          className={styles.btn}
          onClick={this.handleClick}
          disabled={disabled || busy}
          aria-label={label}
        >
          <Icon name={busy ? 'progress_activity' : 'download'} size={16} className={busy ? styles.spin : ''} />
        </button>
      </Tooltip>
    );
  }
}

export default ExportUsersButton;
